<template>
    <!--/ Section Contact-Footer Star /-->
  <section class="paralax-mf footer-paralax bg-image sect-mt4 route" style="background-image: url(images/overlay-bg.webp)">
    <div class="overlay-mf"></div>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="contact-mf">
            <div id="contact" class="box-shadow-full">
              <div class="row">
                <div class="col-md-6">
                  <div class="title-box-2">
                    <h5 class="title-left mt-5">
                      Nos Envie Uma Mensagem
                    </h5>
                  </div>
                  <div>
                      <form @submit.prevent="enviarMensagem()">
                      <div class="row">
                        <div class="col-md-12 mb-3">
                          <div class="form-group">
                            <input type="text" name="nome" class="form-control" id="name" placeholder="Nome" v-model="form.nome" :class="{ 'is-invalid' : form.errors.has('nome') }">
                            <has-error :form="form" field="nome"></has-error>
                          </div>
                        </div>
                        <div class="col-md-12 mb-3">
                          <div class="form-group">
                            <input type="email" class="form-control" name="email" id="email" placeholder="E-mail" v-model="form.email" :class="{ 'is-invalid' : form.errors.has('email') }"/>
                            <has-error :form="form" field="email"></has-error>
                          </div>
                        </div>
                        <div class="col-md-12 mb-3">
                            <div class="form-group">
                              <input type="text" class="form-control" name="assunto" id="subject" placeholder="Assunto" v-model="form.assunto" :class="{ 'is-invalid' : form.errors.has('assunto') }"/>
                              <has-error :form="form" field="assunto"></has-error>
                            </div>
                        </div>
                        <div class="col-md-12 mb-3">
                          <div class="form-group">
                            <textarea class="form-control" name="mensagem" rows="15" v-model="form.mensagem" placeholder="Mensagem" :class="{ 'is-invalid' : form.errors.has('mensagem') }"></textarea>
                            <has-error :form="form" field="mensagem"></has-error>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <button type="submit" class="button button-a button-big button-rouded">Enviar Mensagem</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="title-box-2 pt-4 pt-md-0">
                    <h5 class="title-left mt-5">
                      Entre em Contato conosco:
                    </h5>
                  </div>
                  <div class="more-info">
                    <p class="lead">
                      Você pode nos encontrar em qualquer uma das nossas redes sociais ou até nos nossos endereços:
                    </p>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for='Filial'>Escolha uma filial: <span class="text-danger">*</span> </label>
                            <vue-multiselect 
                                v-model="filial" 
                                :options="this.filiais"
                                :multiple="false"
                                :allow-empty="false"
                                :custom-label="customLabel"
                                selectLabel="Enter p/ selecionar"
                                selectedLabel="Selecionado"
                                placeholder="Escolha uma filial"
                                id="Filial"
                                locale="pt-BR"
                            >
                              <template v-slot:noResult>
                                Nada encontrado.
                              </template>
                              <template v-slot:noOptions>
                                Nada encontrado.
                              </template>
                            </vue-multiselect>
                            <has-error :form="form" field="filial_id"></has-error>
                        </div>
                    </div>
                    <ul class="list-ico">
                      <li><span><i class="fas fa-map-marker-alt" style="color: #3e4095"></i></span> <a :href="`${this.filial.linkmaps}`">{{this.filial.endereco}}</a></li>
                      <li><span><i class="fas fa-phone-alt" style="color: #3e4095"></i></span> <a :href="`tel:${this.filial.telefone}`">{{this.filial.telefone}}</a></li>
                      <li><span><i class="far fa-envelope" style="color: #3e4095"></i></span> <a :href="`mailto:${this.filial.email}`">{{this.filial.email}}</a></li>
                    </ul>
                  </div>
                  <div class="socials">
                    <div><a href="https://www.facebook.com/supersafraagropecuaria/">
                    <i class="fab fa-facebook-f"></i> Agropecuária
                    </a></div>
                    <div><a href="https://www.facebook.com/supersafratratoresteofilootoni/">
                    <i class="fab fa-facebook-f"></i> Concessionária Massey Ferguson
                    </a></div>
                    <div><a href="https://www.instagram.com/supersafraagropecuaria/">
                    <i class="fab fa-instagram"></i> Agropecuária
                    </a></div>
                    <div><a href="https://www.instagram.com/supersafratratores/">
                    <i class="fab fa-instagram"></i> Concessionária Massey Ferguson
                    </a></div>
                  </div>
                  <div class="" v-if="filial.embedMaps != ''">
                    <iframe :src="filial.embedMaps" width="100%" height="350" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="copyright-box">
              <p class="copyright">&copy; Copyright - Grupo Super Safra - Desenvolvedor: <strong>Lucas Carvalho</strong></p>
              <div class="credits">
                <a href="/login">Dashboard access</a> - <button class="btn btn-link btn-sm text-white text-decoration-none" @click.prevent="openModalLDO = !openModalLDO">Políticas de Privacidade e uso dos dados.</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <ldo
      :openThis="openModalLDO"
    ></ldo>
  </section>
  <!--/ Section Contact-footer End /-->
</template>
<script>
import LDOComponent from './LDO.vue';
export default {
    data(){
      return{
        filiais: window.filiais,
        filial: '',
        filial_escolhida: window.filial,
        form: new Form({
            id: '',
            nome: '',
            email: '',
            assunto: '',
            mensagem: ''
        }),
        openModalLDO: false,
      }
    },
    methods:{
      enviarMensagem(){
          this.$Progress.start();
          this.form.post('/api/sendMessage')
          .then(()=>{
              toast.fire({
                  icon: 'success',
                  title: 'Enviado com sucesso.'
              });
              this.form.clear();
              this.form.reset();
              this.$Progress.finish();
          })
          .catch(()=>{
              toast.fire({
                  icon: 'error',
                  title: 'Não enviado. Algo aconteceu...'
              });
              this.$Progress.fail();
          });
      },
      customLabel({nome, endereco, linkmaps, telefone, email, embedMaps}){
        return `${nome}`;
      },
    },
    mounted(){
      if(this.filial_escolhida != null && this.filial_escolhida != '' && typeof this.filial_escolhida != 'undefined'){
        this.filiais.forEach((el, i, arr) => {
          if(el.area_url == this.filial_escolhida){
            this.filial = el;
          }
        });
      }
    },
    components: {
      'ldo': LDOComponent
    }
}
</script>